import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
export function Dashboard() {
  return <div className="space-y-6" data-id="element-455" data-mp="oz0iblsuh65h">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-456" data-mp="13og8azkjx7k4">Order Info</h1>

      <p className="text-slate-600" data-id="element-457" data-mp="13noadi3hexqo">
        Below is information about the new orders placed by your customers this
        month/this week/today or since your last log in to the administrator
        area.
      </p>

      <Card data-id="element-458" data-mp="b1lp05zh0e88">
        <CardContent className="p-0" data-id="element-459" data-mp="60xpevx6ep2e">
          <div className="overflow-x-auto" data-id="element-460" data-mp="61zdq237d822">
            <table className="w-full text-sm text-left" data-id="element-461" data-mp="632488wm58hg">
              <thead className="bg-slate-800 text-white" data-id="element-462" data-mp="kyq2zij5x3dy">
                <tr data-id="element-463" data-mp="fz53n702yt0p">
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-464" data-mp="fyluaeohxcya">
                    Status
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-465" data-mp="1reaj7blb8m1q">
                    Since Last Login
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-466" data-mp="26oric5huz36k">
                    Today
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-467" data-mp="2bom7a3i2pioz">
                    This Week
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700" data-id="element-468" data-mp="1j0gm5fn3xrom">
                    This Month
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-469" data-mp="1rzlkakurbj09">
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-470" data-mp="1ry0q4wccu22x">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-471" data-mp="1ws4xvhtg2e52">
                    Processed
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-472" data-mp="14a9e7tuq7r26">
                    34
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-473" data-mp="27k53ithzjm1f">
                    20
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-474" data-mp="22ltu2jvlrdjq">
                    66
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-475" data-mp="2cbwu34155rrk">189</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-476" data-mp="2ce9d7kimy867">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-477" data-mp="1omufk51t0f1a">
                    Failed/Declined
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-478" data-mp="1xmqzxuh5urqj">
                    2
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-479" data-mp="1tkcgb85o3ny7">
                    1
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-480" data-mp="390copej3yrbj">
                    3
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-481" data-mp="3ck3d6bzsmexr">10</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-482" data-mp="3cmg2593yxpkb">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-483" data-mp="3hkrbliqcpy20">
                    Not Finished
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-484" data-mp="37l0eraebj6yr">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-485" data-mp="3vbmduc6chgwm">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-486" data-mp="43ia1btueg2k">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-487" data-mp="3qjuvuq198ji3">0</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-488" data-mp="3qhi5pplcf2ty">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-489" data-mp="i2hzumt3d10b">
                    Total Paid
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-490" data-mp="2vbuaknw6jv8r">
                    $1325.24
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-491" data-mp="2qbptavng6whh">
                    $724.58
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-492" data-mp="2ldwljy6hxuf3">
                    $3078.7
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-493" data-mp="3e229etsujzj5">$9063.84</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

      <div data-id="element-494" data-mp="395lcpb7l0cug">
        <Link to="/orders" className="text-blue-600 hover:text-blue-800 hover:underline text-sm font-medium" data-id="element-495" data-mp="34c8y7twm9mff">
          Order Search
        </Link>
      </div>
    </div>;
}